import {
  HttpClient,
  HttpContext,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { constants } from '../../../constants';
import { BYPASS_HANDLER } from '../../main/interceptors/global-error-interceptor';
import { UserData } from '../models/user-data.model';
import { UserFreemium } from '../../auth/models/user.model';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}

  public getAll(): Observable<UserData[]> {
    return this.http.get<UserData[]>(constants.uriParts.user);
  }

  public getAllInLoggedOrg(): Observable<UserData[]> {
    return this.http.get<UserData[]>(constants.uriParts.usersInLoggedOrg);
  }

  public getAllInOrg(orgId: string): Observable<UserData[]> {
    return this.http.get<UserData[]>(
      `${constants.uriParts.usersInOrg}/${orgId}`
    );
  }

  public getUser() {
    return this.http.get<UserData>(constants.uriParts.loggedUser);
  }

  public createOrUpdateUser(
    user: UserData,
    sendInvitationEmail: boolean,
    skipGlobalHandler = false
  ): Observable<UserData> {
    if (user.id) {
      return this.http.put(`${constants.uriParts.user}/${user.id}`, user);
    }

    let queryParams = new HttpParams();
    queryParams = queryParams.append(
      'sendInvitationEmail',
      sendInvitationEmail
    );

    return this.http.post(constants.uriParts.user, user, {
      params: queryParams,
      context: new HttpContext().set(BYPASS_HANDLER, skipGlobalHandler),
    });
  }

  public sendInvitationEmail(user: UserData) {
    return this.http.post(
      `${constants.uriParts.user}/${user.id}/send-invitation-email`,
      null
    );
  }

  public deleteUser(userId: string): Observable<UserData> {
    return this.http.delete(constants.uriParts.user + `/${userId}`);
  }

  public createAdminUser(
    user: UserData,
    sendInvitationEmail: boolean
  ): Observable<UserData> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append(
      'sendInvitationEmail',
      sendInvitationEmail
    );

    return this.http.post(constants.uriParts.adminUser, user, {
      params: queryParams,
    });
  }

  public getUserByEmailSecret(
    userId: string,
    emailSecret: string,
    skipGlobalHandler = false
  ): Observable<HttpResponse<UserData>> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('userId', userId);
    queryParams = queryParams.append('emailSecret', emailSecret);

    return this.http.get(constants.uriParts.userEmailDetails, {
      params: queryParams,
      observe: 'response',
      context: new HttpContext().set(BYPASS_HANDLER, skipGlobalHandler),
    });
  }

  public enableUser(emailSecret: string, user: UserData): Observable<UserData> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('emailSecret', emailSecret);

    return this.http.post(
      `${constants.uriParts.user}/${user.id}/enable`,
      user,
      { params: queryParams }
    );
  }

  public passwordValidator(control: AbstractControl): ValidationErrors | null {
    const hasUpper = /[A-Z]/.test(control.value);
    const hasLower = /[a-z]/.test(control.value);
    const hasNumber = /\d/.test(control.value);
    const hasLength = control.value.length >= 8;

    const valid = hasUpper && hasLower && hasNumber && hasLength;

    if (!valid) {
      // return what´s not valid
      return {
        hasUpper,
        hasLower,
        hasNumber,
        hasLength,
      };
    }

    return null;
  }
  public registerFreemiumUser(user: UserFreemium): Observable<any> {
    return this.http.post(`${constants.uriParts.registerFreemiumUser}`, user);
  }
}
